<template>
  <v-dialog v-model="visible" max-width="650" persistent>
    <v-card>
      <v-card-title class="text-h6">
        <div class="title">
          <div>Hantera taggar</div>
          <div class="close-icon" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>

      <v-card-text>
        <v-card flat>
          <v-card-text>
            <v-chip
              v-for="tag in tags"
              :key="tag.id"
              small
              :color="getTagColor(tag.color)"
              label
              class="tags"
              :title="tag.description"
              @click="onChangeTag(tag)"
              :text-color="currentTag && currentTag.id === tag.id ? 'white' : null"
              :outlined="!currentTag || currentTag.id !== tag.id"
            >
              {{ tag.name }}
            </v-chip>
            <v-chip label small class="tags" style="cursor: pointer" @click="onNewTag">
              <v-icon left> mdi-plus </v-icon>
              Lägg till ny tag
            </v-chip>
          </v-card-text>
        </v-card>
        <EditTag
          :tag="currentTag"
          :loading="loading"
          @save="onSave"
          v-if="currentTag"
          @delete="onDelete"
        />
      </v-card-text>
      <!-- 
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'ContactsHome' }"> Stäng </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditTag from '@/components/contacts/EditTag.vue'
import { getTagColor } from '@/assets/data/colors.js'
export default {
  name: 'ContactTagsAdmin',
  components: {
    EditTag,
  },
  data() {
    return {
      visible: true,
      currentTag: null,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('contacts', { tags: 'tags' }),
  },
  methods: {
    ...mapActions('contacts', {
      createContactTag: 'createContactTag',
      updateContactTag: 'updateContactTag',
      deleteContactTag: 'deleteContactTag',
    }),
    getTagColor,
    onClose() {
      this.$router.replace({ name: 'ContactsHome' })
    },

    onNewTag() {
      this.currentTag = { description: '', name: 'Ny tag', color: 'COLOR_1' }
    },
    onChangeTag({ id }) {
      this.currentTag = this.tags.find((t) => t.id === id)
    },
    async onSave(tag) {
      this.loading = true
      if (tag && tag.id) {
        await this.updateContactTag(tag)
      } else {
        const newTag = await this.createContactTag(tag)
        this.onChangeTag(newTag)
      }
      this.loading = false
    },
    async onDelete(tag) {
      this.loading = true
      await this.deleteContactTag(tag)
      this.loading = false
      this.currentTag = null
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.close-icon {
  cursor: pointer;
}
.tags {
  margin-right: 4px;
  margin-bottom: 4px;
}
</style>
